var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "trigger-preview" }, [
    _c("div", [
      _c(
        "div",
        { staticClass: "messages" },
        _vm._l(_vm.getMessageList(), function (message, i) {
          return _c(
            "div",
            {
              directives: [
                {
                  name: "animate-css",
                  rawName: "v-animate-css",
                  value: "fadeInRight",
                  expression: "'fadeInRight'",
                },
                {
                  name: "show",
                  rawName: "v-show",
                  value: i <= _vm.cursor,
                  expression: "i <= cursor",
                },
              ],
              staticClass: "message",
            },
            [_c("span", [_vm._v(_vm._s(message))])]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "bubble" }, [_c("BubblePreview")], 1),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }